import { state } from '../state';
import { get } from '../api';
import { showToast } from '../components/toast';
import { iconActivity } from '../icons';
import type { LogEntry } from '../types';

function esc(str: string): string {
  const el = document.createElement('div');
  el.textContent = str;
  return el.innerHTML;
}

function logRow(entry: LogEntry): string {
  const ts = entry.ts ? new Date(entry.ts).toLocaleString() : '';
  return `
    <tr>
      <td class="log-ts">${esc(ts)}</td>
      <td>${esc(entry.handler)}</td>
      <td class="log-payload">${esc(entry.payload_summary)}</td>
    </tr>`;
}

export function renderLogs(body: HTMLElement): void {
  const logs = state.logs;

  body.innerHTML = `
    <div class="channel-header">
      <h1>${iconActivity()} Logs</h1>
      <div class="channel-actions">
        <button class="btn btn-secondary" id="refresh-logs">Refresh</button>
      </div>
    </div>
    <div class="table-wrap">
      <table class="data-table">
        <thead><tr><th>Timestamp</th><th>Handler</th><th>Payload</th></tr></thead>
        <tbody>
          ${logs.length ? logs.map(l => logRow(l)).join('') : '<tr><td colspan="3" class="empty-state">No log entries</td></tr>'}
        </tbody>
      </table>
    </div>`;

  document.getElementById('refresh-logs')?.addEventListener('click', () => {
    get<LogEntry[]>('/api/logs')
      .then(data => { state.logs = data; renderLogs(body); })
      .catch(e => showToast(String(e), 'err'));
  });
}
